import type { FC } from 'react'

import { Table } from '@skytech/ui'
import Fuse from 'fuse.js'

import { Translation } from '@/app/translations/Translation'
import { NoResults } from '@/components/NoResults'
import type { Department } from '@/types'

import AllDepartmentsCheckbox from './AllDepartmentsCheckbox'
import DepartmentListItem from './DepartmentListItem'

import './DepartmentList.styles.scss'

const DepartmentList: FC<{
  searchQuery: string | null
  selectedDepartmentIds: number[] | null
  departmentList: Department[]
  isSingleChoiceList?: boolean
  onDepartmentSelect: (id: number) => void
  onDepartmentsSelect?: (ids: number[] | null) => void
}> = ({
  searchQuery,
  selectedDepartmentIds,
  departmentList,
  isSingleChoiceList,
  onDepartmentSelect,
  onDepartmentsSelect,
}) => {
  const options = {
    keys: ['id', 'name', 'code', 'customerName'],
  }

  const fuse = new Fuse(departmentList, options)
  const departmentListFiltered = searchQuery ? fuse.search(searchQuery) : []

  return (
    <div className="departments">
      <Table rowHeight="medium">
        <thead>
          <tr>
            {onDepartmentsSelect ? (
              <AllDepartmentsCheckbox
                departmentList={
                  searchQuery?.length
                    ? departmentListFiltered.map(({ item }) => item)
                    : departmentList
                }
                selectedDepartmentIds={selectedDepartmentIds}
                onDepartmentsSelect={onDepartmentsSelect}
              />
            ) : (
              <th />
            )}
            <th>
              <Translation id={isSingleChoiceList ? 'name' : 'Select all'} />
            </th>

            <th className="is-mobile-hidden">
              <Translation id="company name" />
            </th>

            <th>
              <Translation id="code" />
            </th>
          </tr>
        </thead>

        <tbody>
          {/* Hack for the bug of showing no results if the search query is empty https://github.com/krisk/Fuse/issues/229 */}
          {!searchQuery ? (
            <>
              {departmentList.map(departmentListItem => (
                <DepartmentListItem
                  key={departmentListItem.id}
                  searchQuery={searchQuery || undefined}
                  selectedDepartmentIds={selectedDepartmentIds}
                  isSingleChoiceList={isSingleChoiceList}
                  onDepartmentSelect={onDepartmentSelect}
                  {...departmentListItem}
                />
              ))}
            </>
          ) : (
            <>
              {departmentListFiltered.length ? (
                departmentListFiltered.map(({ item: departmentListItem }) => (
                  <DepartmentListItem
                    key={departmentListItem.id}
                    searchQuery={searchQuery}
                    selectedDepartmentIds={selectedDepartmentIds}
                    isSingleChoiceList={isSingleChoiceList}
                    onDepartmentSelect={onDepartmentSelect}
                    {...departmentListItem}
                  />
                ))
              ) : (
                <tr>
                  <td colSpan={4}>
                    <NoResults />
                  </td>
                </tr>
              )}
            </>
          )}
        </tbody>
      </Table>
    </div>
  )
}

export default DepartmentList
